export default function PaginationBar({
  page,
  pageCount,
  onPageChange,
  pageSize,
  onPageSizeChange,
  totalCount
}) {
  if (pageCount <= 1 && totalCount <= pageSize) return null;

  const goTo = (p) => {
    if (p < 1 || p > pageCount) return;
    onPageChange(p);
  };

  return (
    <div className="pagination-bar">
      {/* Page size */}
      <div>
        <span>Rows per page : {" "}</span>
        <select className="button secondary" style={{  padding: "3px 8px"}}
          value={pageSize}
          onChange={(e) => onPageSizeChange(Number(e.target.value))}
        >
          {[10, 25, 50, 100].map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>

      {/* Pagination buttons */}
      <div className="actions">
        <button className="button secondary" disabled={page === 1} onClick={() => goTo(page - 1)}>
          Prev
        </button>

        {[...Array(pageCount).keys()].map((i) => {
          const num = i + 1;
          return (
            <button
              key={num}
              className={num === page ? "button primary" : "button secondary"}
              onClick={() => goTo(num)}
            >
              {num}
            </button>
          );
        })}

        <button className="button secondary" disabled={page === pageCount} onClick={() => goTo(page + 1)}>
          Next
        </button>
      </div>
    </div>
  );
}
